import type { FC } from 'react';
import React from 'react';
import ExternalResourceIcon from '@helpcenter/external-resource-fallback-icon';
import { graphql, useFragment } from 'react-relay';
import { GroupBoxLink } from 'view/common/group-box';
import { getUpdatedDisplayLink } from '@atlassian/help-center-common-util/url';
import { NewTabTooltipContainer } from '../new-tab-tooltip-container';
import type { Props } from './types';

const HelpObjectChannelComponent: FC<Props> = (props) => {
    const data = useFragment<Props['helpObject']>(
        graphql`
            fragment helpObjectChannel_HelpObjectStoreChannel on HelpObjectStoreChannel {
                title
                description
                displayLink
            }
        `,
        props.helpObject
    );

    const { title, description } = data;

    if (title?.length && data.displayLink && typeof data.displayLink === 'string') {
        return (
            <NewTabTooltipContainer shouldOpenInANewTab>
                <GroupBoxLink
                    target="_blank"
                    href={getUpdatedDisplayLink(data.displayLink)}
                    icon={
                        <ExternalResourceIcon
                            iconUrl={getUpdatedDisplayLink(data.displayLink)}
                            resourceType="CHANNEL"
                            size="large"
                        />
                    }
                    heading={title}
                    description={description}
                    actionSubjectId="helpObject"
                ></GroupBoxLink>
            </NewTabTooltipContainer>
        );
    }
    return null;
};

export default HelpObjectChannelComponent;
